import { ref } from 'vue'

// Id da conversa: number no Chatwoot antigo (FocoView.vue/MobileView.vue, fora de escopo),
// string (Guid) no WootDash — o mesmo sinal global serve os dois mundos sem duplicar o
// mecanismo de "abrir esta conversa" (ver ConvDrawer.vue portado).
export type ChatId = number | string

export const pendingChatId      = ref<ChatId | null>(null)
export const currentOpenConvId  = ref<ChatId | null>(null)
export const convNavList        = ref<ChatId[]>([])
export const closeDrawerSignal  = ref(0)
export const focusReplySignal   = ref(0)
export const openMyConvsSignal  = ref(0)
// Contexto da conversa que o agente está atendendo agora na ConvDrawer (null quando nenhuma está
// aberta). Usado pelo ChatWidget (Beto) pra decidir quando mostrar o balão de ajuda e, no fluxo 2
// (Empresa Cliente) com CNPJ preenchido, disparar a consulta automática — ver
// docs/planos/PILOTO-BETO-CNPJ.md.
export interface ActiveConvContext { id: ChatId; fluxoId: number | null; cnpj: string | null }
export const activeConvContext  = ref<ActiveConvContext | null>(null)
// Clique no botão "Visualizar filtro Mês" da notificação (ver services/notifications.ts
// + public/sw-notif.js) — DashboardView.vue consome isso pra trocar o período pra "month".
// Fica pendente até ser consumido: pode chegar antes da view estar montada (navegação
// vinda de outra rota), por isso não é um contador incrementável como os signals acima.
export const pendingMonthFilter = ref(false)

export function requestOpenChat(id: ChatId)    { pendingChatId.value = id }
export function setConvNavList(ids: ChatId[])  { convNavList.value = ids }
export function closeDrawer()                  { closeDrawerSignal.value++ }
export function requestFocusReply()            { focusReplySignal.value++ }
export function requestOpenMyConvs()            { openMyConvsSignal.value++ }
export function requestViewMonthFilter()        { pendingMonthFilter.value = true }

export function goNextConv() {
  const list = convNavList.value
  if (!list.length) return
  const curr = currentOpenConvId.value
  if (curr === null) { requestOpenChat(list[0]); return }
  const idx = list.indexOf(curr)
  if (idx !== -1 && idx < list.length - 1) requestOpenChat(list[idx + 1])
}

export function goPrevConv() {
  const list = convNavList.value
  if (!list.length) return
  const curr = currentOpenConvId.value
  if (curr === null) { requestOpenChat(list[0]); return }
  const idx = list.indexOf(curr)
  if (idx > 0) requestOpenChat(list[idx - 1])
}
